// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/2024-07-25/" + ({"188":"video_localization_editor","566":"resources","569":"voice_editor","630":"others","690":"manage","824":"ai-writing-editor","962":"home","983":"products","990":"talking_photo_editor"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".js";
};